import _ from 'lodash';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    RESIDUALS_FAILURE,
    RESIDUALS_LOAD,
    RESIDUALS_SUCCESS
} from './residualsActions';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                residuals: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case RESIDUALS_LOAD:
            newState = {
                ...state,
                residuals: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case RESIDUALS_SUCCESS:
            newState = {
                ...state,
                residuals: action.residuals,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case RESIDUALS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getResidualsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'residuals')
);

export const getPages = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'pages')
);

export const getCount = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'count')
);

export const getIsResidualsLoading = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'loading')
);

export const getResiduals = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'residuals')
);

export const getResidualsError = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'error')
);

export const getResidualsErrorMessage = createSelector(
    getResidualsError,
    (error) => _.get(error, 'message')
);

export const getHasMore = createSelector(
    getResidualsEntity,
    (entity) => _.get(entity, 'hasMore')
);

